const TooltipPlugin = {
    init: ($) => {
        if ($.fn.tooltip) {
            $('[data-toggle="tooltip"]').tooltip();
        }
    },
};

export default TooltipPlugin;
